const channels = new Map();

export const broadcastCore = {
  getChannel(name) {
    if (!channels.has(name)) {
      const channel = new BroadcastChannel(name);
      const listeners = new Set();

      channel.onmessage = (e) => {
        const { type } = e.data || {};
        for (const { callback, filterType } of listeners) {
          if (!filterType || filterType === type) {
            callback(e.data);
          }
        }
      };

      channels.set(name, { channel, listeners });
    }
    return channels.get(name);
  },

  subscribe(channelName, callback, filterType = null) {
    const { listeners } = this.getChannel(channelName);
    const obj = { callback, filterType };
    listeners.add(obj);
    return () => listeners.delete(obj);
  },

  send(channelName, message) {
    const { channel } = this.getChannel(channelName);
    channel.postMessage(message);
  },

  close(channelName) {
    const data = channels.get(channelName);
    if (data) {
      data.channel.close();
      channels.delete(channelName);
    }
  },

  closeAll() {
    for (const { channel } of channels.values()) {
      channel.close();
    }
    channels.clear();
  },
};
